var _linearGradient, _path, _linearGradient2, _path2, _path3, _linearGradient3, _polygon, _linearGradient4, _path4, _rect, _rect2, _linearGradient5, _path5, _linearGradient6, _path6, _rect3, _path7, _linearGradient7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Foundation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bRSbcyBkZmdNnOpQikDM~a",
    x1: 15.197,
    x2: 28.404,
    y1: 9.352,
    y2: 22.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1aab3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f979e"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bRSbcyBkZmdNnOpQikDM~a)",
    d: "M18.67,20.954l11.345-3.033c0.986-0.264,1.317-1.496,0.595-2.219l-8.313-8.313 c-0.722-0.722-1.955-0.391-2.219,0.595L17.046,19.33C16.783,20.315,17.685,21.217,18.67,20.954z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bRSbcyBkZmdNnOpQikDM~b",
    x1: 365.733,
    x2: 368.468,
    y1: 222.478,
    y2: 220.541,
    gradientTransform: "scale(-1 1) rotate(-45 -84.606 591.59)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c8cdd1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b3b3b3"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bRSbcyBkZmdNnOpQikDM~b)",
    d: "M25.19,12.811L25.19,12.811c0.253,0.253,0.662,0.253,0.914,0L29,9.915L28.086,9l-2.896,2.896 C24.937,12.148,24.937,12.558,25.19,12.811z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ad570d",
    d: "M33.558,4.442L33.558,4.442c0.59,0.59,0.59,1.546,0,2.135L29.135,11L27,8.865l4.423-4.423 C32.013,3.853,32.968,3.853,33.558,4.442z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bRSbcyBkZmdNnOpQikDM~c",
    x1: 365.15,
    x2: 368.169,
    y1: 219.848,
    y2: 219.848,
    gradientTransform: "scale(-1 1) rotate(-45 -84.606 591.59)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dd7d22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d97218"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#bRSbcyBkZmdNnOpQikDM~c)",
    points: "27.61,8.255 29.745,10.39 29.135,11 27,8.865"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bRSbcyBkZmdNnOpQikDM~d",
    x1: 24,
    x2: 24,
    y1: 36.605,
    y2: 42.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.012,
    stopColor: "#f3653d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.326,
    stopColor: "#f05b31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523,
    stopColor: "#ee552a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ed5328"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bRSbcyBkZmdNnOpQikDM~d)",
    d: "M45,37H3c-0.552,0-1,0.448-1,1v3c0,0.552,0.448,1,1,1h42c0.552,0,1-0.448,1-1v-3 C46,37.448,45.552,37,45,37z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 5,
    x: 15,
    y: 37,
    fill: "#f6eca5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 5,
    x: 31,
    y: 37,
    fill: "#f6eca5"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bRSbcyBkZmdNnOpQikDM~e",
    x1: 16.5,
    x2: 16.5,
    y1: 29.447,
    y2: 38.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.012,
    stopColor: "#f3653d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.326,
    stopColor: "#f05b31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523,
    stopColor: "#ee552a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ed5328"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bRSbcyBkZmdNnOpQikDM~e)",
    d: "M24,30H10c-0.552,0-1,0.448-1,1v5c0,0.552,0.448,1,1,1h14V30z"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bRSbcyBkZmdNnOpQikDM~f",
    x1: 31.5,
    x2: 31.5,
    y1: 29.447,
    y2: 38.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.012,
    stopColor: "#f3653d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.326,
    stopColor: "#f05b31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523,
    stopColor: "#ee552a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ed5328"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bRSbcyBkZmdNnOpQikDM~f)",
    d: "M38,30H24v7h14c0.552,0,1-0.448,1-1v-5C39,30.448,38.552,30,38,30z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 7,
    x: 23,
    y: 30,
    fill: "#f6eca5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6eca5",
    d: "M38,37H10c-0.552,0-1-0.448-1-1v-1h30v1C39,36.552,38.552,37,38,37z"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "bRSbcyBkZmdNnOpQikDM~g",
    x1: 24,
    x2: 24,
    y1: 23.526,
    y2: 31.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.012,
    stopColor: "#f3653d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.326,
    stopColor: "#f05b31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523,
    stopColor: "#ee552a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ed5328"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bRSbcyBkZmdNnOpQikDM~g)",
    d: "M30,24H18c-0.552,0-1,0.448-1,1v4c0,0.552,0.448,1,1,1h12c0.552,0,1-0.448,1-1v-4 C31,24.448,30.552,24,30,24z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6eca5",
    d: "M30,30H18c-0.552,0-1-0.448-1-1v-1h14v1C31,29.552,30.552,30,30,30z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Foundation);
export default __webpack_public_path__ + "static/media/icons8-foundation.5925e4c749af9de379bddc86cc151387.svg";
export { ForwardRef as ReactComponent };